export default "__VITE_ASSET__nVtAEGOy__"